import styled from 'styled-components';

const Root = styled.thead `
  background-color: ${props => props.theme.colors.gray50};
`;

export { Root };
//# sourceMappingURL=styled.js.map
